import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";
import { Header } from "@/pages/Templates/Header";
import { Menu } from "@/pages/Templates/Menu";
import { useAuthUser } from "@/hooks/useAuthUser";
import { AlertHeader } from "@/components/molecules/AlertHeader";

const mdTheme = createTheme({
  palette: {
    primary: {
      main: "#4caf50",
      dark: "#388e3c",
      contrastText: "#fff",
    },
    secondary: {
      main: "#607d8b",
      dark: "#455a64",
      contrastText: "#fff",
    },
  },
});

const LayoutContent = () => {
  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const { infoHeaders } = useAuthUser();

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        {/* Header Content */}
        <Header open={open} toggleDrawer={toggleDrawer} />

        {/* サイドメニュー */}
        <Menu open={open} toggleDrawer={toggleDrawer} />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />

          {/* ドメインエリア(ページ遷移でこの下が切り替わる) */}
          <Container
            sx={{ mt: 2, mb: 2, maxWidth: "100%" }}
            style={{ maxWidth: "100%" }}
          >
            {/* アナウンスがある場合表示 */}
            {infoHeaders.map((announcement) => (
              <AlertHeader key={announcement.id} content={announcement.detail} />
            ))}
            <Outlet />
            <Footer sx={{ pt: 4 }} />
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export const Layout = () => {
  return <LayoutContent />;
};
